import * as StorageService from "../services/StorageService.js";
import {LOCALSTORAGE_ITEMS} from "../util/Constants";
import * as RestClient from "../util/api/restClient";
import * as ClientConfig from "../config/ClientConfig";


const createProductsOrderStripePaymentLink =  async (req) => {
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/user/stripe/createproductsorderpaymentlink";
        const response = fetch(finalURL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Zoniz-Token": StorageService.getItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN),
                "X-Zoniz-User-Email": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            },
            body: JSON.stringify(req),
        });
        return response;
    });
}


const createProductsOrderPaymentLink =  async (req) => {
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/user/createproductsorderpaymentlink";
        const response = fetch(finalURL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Zoniz-Token": StorageService.getItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN),
                "X-Zoniz-User-Email": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            },
            body: JSON.stringify(req),
        });
        return response;
    });
}



const payProductsOrder =  async (req) => {
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/user/payproductsorder";
        const response = fetch(finalURL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Zoniz-Token": StorageService.getItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN),
                "X-Zoniz-User-Email": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            },
            body: JSON.stringify(req),
        });
        return response;
    });
}

const savePaymentCard =  async (req) => {
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/user/savepaymentcard";
        const response = fetch(finalURL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Zoniz-Token": StorageService.getItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN),
                "X-Zoniz-User-Email": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            },
            body: JSON.stringify(req),
        });
        return response;
    });
}


export {
    createProductsOrderStripePaymentLink,
    createProductsOrderPaymentLink,
    savePaymentCard,
    payProductsOrder

}
